import React from 'react';
import { iterateTimes } from '../utility/calendar';
import { TimelineStateConsumer } from '../timeline/TimelineStateContext';
import type { TimelineTimeSteps } from '../types/main';

interface WrapperColumnsProps {
  canvasTimeStart: number;
  canvasTimeEnd: number;
  canvasWidth: number;
  lineCount: number;
  minUnit: keyof TimelineTimeSteps;
  timeSteps: TimelineTimeSteps;
  height: number;
  verticalLineClassNamesForTime?: (a: number, b: number) => string[];
}

interface ColumnsProps extends WrapperColumnsProps {
  getLeftOffsetFromDate: (time: number) => number;
}

function Columns({
  canvasTimeStart,
  canvasTimeEnd,
  minUnit,
  timeSteps,
  height,
  verticalLineClassNamesForTime,
  getLeftOffsetFromDate,
}: ColumnsProps) {
  const lines: React.JSX.Element[] = [];

  iterateTimes(canvasTimeStart, canvasTimeEnd, minUnit, timeSteps, (time, nextTime) => {
    const minUnitValue = time.get(minUnit === 'day' ? 'date' : minUnit);
    const firstOfType = minUnitValue === (minUnit === 'day' ? 1 : 0);

    let classNamesForTime: string[] = [];
    if (verticalLineClassNamesForTime) {
      classNamesForTime = verticalLineClassNamesForTime(
        time.unix() * 1000,
        nextTime.unix() * 1000 - 1,
      );
    }

    // Misma construcción exacta que el original para no alterar estilos
    const classNames =
      'rct-vl' +
      (firstOfType ? ' rct-vl-first' : '') +
      (minUnit === 'day' || minUnit === 'hour' || minUnit === 'minute'
        ? ` rct-day-${time.day()} `
        : ' ') +
      classNamesForTime.join(' ');

    const left = getLeftOffsetFromDate(time.valueOf());
    const right = getLeftOffsetFromDate(nextTime.valueOf());
    lines.push(
      <div
        key={`line-${time.valueOf()}`}
        className={classNames}
        style={{
          pointerEvents: 'none',
          top: '0px',
          left: `${left}px`,
          width: `${right - left}px`,
          height: `${height}px`,
        }}
      />,
    );
  });

  return <div className="rct-vertical-lines">{lines}</div>;
}

function ColumnsWrapper(props: WrapperColumnsProps) {
  return (
    <TimelineStateConsumer>
      {({ getLeftOffsetFromDate }) => (
        <Columns getLeftOffsetFromDate={getLeftOffsetFromDate} {...props} />
      )}
    </TimelineStateConsumer>
  );
}

ColumnsWrapper.displayName = 'ColumnsWrapper';

export default ColumnsWrapper;
